/* ═══════════════════════════════════════════════════════
   CHOZN — THEME JS v2
   Premium Consumer Commerce · Warm Premium Light
   ═══════════════════════════════════════════════════════ */

/* ── UTILITY ─────────────────────────────────────────── */
const $ = (s, ctx = document) => ctx.querySelector(s);
const $$ = (s, ctx = document) => [...ctx.querySelectorAll(s)];
const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);

/* Respect prefers-reduced-motion */
const prefersReducedMotion = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ── MONEY FORMAT ─────────────────────────────────────── */
function formatMoney(cents) {
  return '₹' + (cents / 100).toLocaleString('en-IN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
}

/* ── TOAST ───────────────────────────────────────────── */
function showToast(msg) {
  const t = $('#toast');
  if (!t) return;
  const m = $('#toastMsg');
  if (m) m.textContent = msg;
  t.classList.add('show');
  clearTimeout(t._timer);
  t._timer = setTimeout(() => t.classList.remove('show'), 3400);
}

/* ── CART COUNT ──────────────────────────────────────── */
function updateCartCount(count) {
  $$('.cart-count').forEach(el => {
    el.textContent = count;
    if (!prefersReducedMotion()) {
      el.classList.remove('cart-count--bump');
      void el.offsetWidth; /* reflow to restart */
      el.classList.add('cart-count--bump');
    }
  });
}

/* ── CART DRAWER ─────────────────────────────────────── */
const cartDrawer = {
  el: null,
  overlay: null,

  init() {
    this.el = $('#cartDrawer');
    this.overlay = $('#cartDrawerOverlay');
    if (!this.el) return;
    on($('#cartDrawerClose'), 'click', () => this.close());
    on(this.overlay, 'click', () => this.close());
    document.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); });
    $$('[data-open-cart]').forEach(btn => on(btn, 'click', e => {
      e.preventDefault();
      this.open();
    }));
  },

  open() {
    if (!this.el) return;
    this.overlay.style.display = 'block';
    requestAnimationFrame(() => {
      this.el.classList.add('open');
      this.overlay.classList.add('open');
    });
    document.body.classList.add('cart-open');
    this.el.setAttribute('aria-hidden', 'false');
    this.render();
    const closeBtn = $('#cartDrawerClose');
    if (closeBtn) setTimeout(() => closeBtn.focus(), 50);
  },

  close() {
    if (!this.el) return;
    this.el.classList.remove('open');
    this.overlay.classList.remove('open');
    document.body.classList.remove('cart-open');
    this.el.setAttribute('aria-hidden', 'true');
    setTimeout(() => {
      if (!this.overlay.classList.contains('open')) this.overlay.style.display = 'none';
    }, 460);
  },

  renderShippingBar(cart) {
    const threshold = 59900; /* ₹599 */
    if (!cart.item_count) return '';
    const remaining = threshold - cart.total_price;
    if (remaining <= 0) {
      return `<div class="cart-shipping-bar cart-shipping-bar--achieved">
        <div class="cart-shipping-bar-achieved-text">
          <svg viewBox="0 0 24 24" width="13" height="13" fill="currentColor">
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
          </svg>
          Free Delivery Above ₹599 unlocked
        </div>
      </div>`;
    }
    const pct = Math.round((cart.total_price / threshold) * 100);
    return `<div class="cart-shipping-bar">
      <div class="cart-shipping-bar-text">
        Add <strong>${formatMoney(remaining)}</strong> more for Free Delivery Above ₹599
      </div>
      <div class="cart-shipping-bar-track">
        <div class="cart-shipping-bar-fill" style="width:${pct}%"></div>
      </div>
    </div>`;
  },

  async render() {
    const itemsEl = $('#cartDrawerItems');
    const totalEl = $('#cartDrawerTotal');
    if (!itemsEl) return;

    itemsEl.innerHTML = `
      <div style="display:flex;align-items:center;justify-content:center;height:120px;
        color:var(--text-muted);font-size:14px;gap:8px;">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"
          style="animation:spin .7s linear infinite;opacity:.5">
          <path d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"/>
        </svg> Loading…
      </div>`;

    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      updateCartCount(cart.item_count);
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

      /* Remove stale shipping bar from previous render */
      const existingBar = this.el.querySelector('.cart-shipping-bar');
      if (existingBar) existingBar.remove();

      if (cart.item_count === 0) {
        itemsEl.innerHTML = `
          <div class="cart-empty">
            <svg viewBox="0 0 24 24" width="48" height="48" fill="currentColor">
              <path d="M17 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59L5.25
              14c-.16.28-.25.61-.25.96C5 16.1 5.9 17 7 17h12v-2H7.42a.25.25 0 0
              1-.25-.25l.03-.12.9-1.63H19c.75 0 1.41-.41 1.75-1.03L23.7 6.5A1 1 0 0 0
              22.82 5H5.21l-.94-2H1zm6 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
            </svg>
            <p>Your cart is empty</p>
            <p class="cart-empty-sub">Your pet deserves the best — start exploring.</p>
            <a href="/collections/all" class="btn-primary" onclick="cartDrawer.close()"
              style="margin-top:8px;border-radius:var(--r);">
              Shop Clean Treats
            </a>
          </div>`;
        return;
      }

      itemsEl.innerHTML = cart.items.map(item => `
        <div class="cart-item" data-key="${item.key}">
          <div class="cart-item-img">
            ${item.image
              ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy">`
              : `<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;background:var(--bg-alt);">
                  <svg viewBox="0 0 24 24" width="24" height="24" fill="var(--text-faint)">
                    <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>
                  </svg>
                </div>`}
          </div>
          <div class="cart-item-info">
            <div class="cart-item-name">${item.product_title}</div>
            ${item.variant_title && item.variant_title !== 'Default Title'
              ? `<div class="cart-item-variant">${item.variant_title}</div>` : ''}
            <div class="cart-item-row">
              <div class="cart-item-qty">
                <button class="cart-qty-btn"
                  onclick="cartDrawer.changeQty('${item.key}', ${item.quantity - 1})">−</button>
                <span class="cart-item-qty-num">${item.quantity}</span>
                <button class="cart-qty-btn"
                  onclick="cartDrawer.changeQty('${item.key}', ${item.quantity + 1})">+</button>
              </div>
              <button class="cart-remove-btn"
                onclick="cartDrawer.changeQty('${item.key}', 0)" title="Remove">
                <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19
                  12 13.41 17.59 19 19 17.59 13.41 12z"/>
                </svg>
              </button>
            </div>
          </div>
          <div class="cart-item-price">${formatMoney(item.line_price)}</div>
        </div>
      `).join('');

      /* Insert shipping progress bar above items list */
      const shippingHTML = this.renderShippingBar(cart);
      if (shippingHTML) {
        const shippingEl = document.createElement('div');
        shippingEl.innerHTML = shippingHTML;
        itemsEl.before(shippingEl.firstElementChild);
      }

    } catch (err) {
      console.error('Cart render error:', err);
      itemsEl.innerHTML = `<p style="text-align:center;padding:24px;color:var(--text-muted);font-size:14px;">Unable to load cart.</p>`;
    }
  },

  async changeQty(key, qty) {
    try {
      const cart = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(r => r.json());
      updateCartCount(cart.item_count);
      this.render();
    } catch (err) {
      console.error('Cart change error:', err);
    }
  }
};

/* ── ADD TO CART ─────────────────────────────────────── */
function addToCartShopify(variantId, buttonEl, qty) {
  qty = qty || 1;
  const original = buttonEl ? buttonEl.innerHTML : '';

  if (buttonEl) {
    buttonEl.disabled = true;
    buttonEl.innerHTML = `<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"
      style="animation:spin .6s linear infinite">
      <path d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"/>
    </svg>`;
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty })
  })
  .then(r => r.json())
  .then(item => {
    if (item.status === 422) throw new Error(item.description || 'Out of stock');
    showToast(item.product_title + ' added to cart!');
    if (buttonEl) { buttonEl.disabled = false; buttonEl.innerHTML = original; }
    cartDrawer.open();
  })
  .catch(() => {
    showToast('Could not add to cart. Please try again.');
    if (buttonEl) { buttonEl.disabled = false; buttonEl.innerHTML = original; }
  });
}

/* ── CART PAGE: UPDATE QTY ───────────────────────────── */
function updateCartQty(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(r => r.json())
  .then(() => location.reload())
  .catch(err => console.error('Cart qty error:', err));
}

/* ── PROMO CODE ──────────────────────────────────────── */
function applyPromo() {
  const input = $('#promoInput');
  if (!input) return;
  const code = input.value.trim().toUpperCase();
  if (!code) { showToast('Please enter a promo code.'); return; }
  showToast(`Code "${code}" will be applied at checkout.`);
}

/* ── STICKY HEADER ───────────────────────────────────── */
function initStickyHeader() {
  const header = $('.site-header');
  if (!header) return;
  on(window, 'scroll', () => {
    header.classList.toggle('scrolled', window.scrollY > 20);
  }, { passive: true });
}

/* ── MOBILE NAV ──────────────────────────────────────── */
function initMobileNav() {
  const hamburger = $('#navHamburger');
  const nav = $('#mobileNav');
  const overlay = $('#mobileNavOverlay');
  const closeBtn = $('#mobileNavClose');
  if (!hamburger || !nav) return;

  const open = () => {
    overlay.style.display = 'block';
    requestAnimationFrame(() => {
      nav.classList.add('open');
      overlay.classList.add('open');
    });
    hamburger.setAttribute('aria-expanded', 'true');
    nav.setAttribute('aria-hidden', 'false');
    document.body.classList.add('nav-open');
    /* Move focus into nav */
    const firstLink = nav.querySelector('a');
    if (firstLink) firstLink.focus();
  };

  const close = () => {
    nav.classList.remove('open');
    overlay.classList.remove('open');
    hamburger.setAttribute('aria-expanded', 'false');
    nav.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nav-open');
    setTimeout(() => {
      if (!overlay.classList.contains('open')) overlay.style.display = 'none';
    }, 460);
  };

  on(hamburger, 'click', () => nav.classList.contains('open') ? close() : open());
  on(closeBtn, 'click', close);
  on(overlay, 'click', close);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
  nav.querySelectorAll('a').forEach(a => on(a, 'click', close));
}

/* ── SCROLL REVEAL ───────────────────────────────────── */
function initScrollReveal() {
  if (prefersReducedMotion()) {
    /* Make all reveals instantly visible */
    $$('.reveal, .reveal-up, .reveal-left, .reveal-right, .reveal-scale, .reveal-fade').forEach(el => {
      el.classList.add('visible');
    });
    return;
  }

  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });

  $$('.reveal, .reveal-up, .reveal-left, .reveal-right, .reveal-scale, .reveal-fade').forEach(el => {
    obs.observe(el);
  });
}

/* ── PRODUCT FILTER (smooth) ─────────────────────────── */
function initProductFilter() {
  const btns = $$('.filter-btn');
  const cards = $$('.product-card');
  if (!btns.length) return;

  const emptyEl = $('#collectionEmptyFilter');

  btns.forEach(btn => {
    on(btn, 'click', function () {
      btns.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      const f = this.dataset.filter;
      let visibleCount = 0;
      cards.forEach(c => {
        const matches = f === 'all' || c.dataset.category === f;
        c.classList.toggle('is-hidden', !matches);
        if (matches) visibleCount++;
      });
      if (emptyEl) emptyEl.style.display = visibleCount === 0 ? 'block' : 'none';
    });
  });
}

/* ── PDP: THUMBNAIL GALLERY ──────────────────────────── */
function initPDPGallery() {
  const track   = $('#pdpSlidesTrack');
  const gallery = $('#pdpGallery');
  if (!track || !gallery) return;

  const slides  = track.querySelectorAll('.pdp-slide');
  const dots    = $$('.pdp-dot');
  const thumbs  = $$('.pdp-thumb-item');
  const prevBtn = $('#pdpPrev');
  const nextBtn = $('#pdpNext');
  const total   = slides.length;
  if (total < 2) return;

  let current    = 0;
  let autoTimer  = null;
  let touchStartX = 0;
  let touchStartY = 0;
  let isDragging  = false;
  let dragStartX  = 0;
  let dragOffset  = 0;

  function goTo(idx, animate) {
    current = (idx + total) % total;
    if (animate !== false) {
      track.style.transition = 'transform 0.46s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    }
    track.style.transform = `translateX(-${current * 100}%)`;

    dots.forEach((d, i) => {
      d.classList.toggle('active', i === current);
      d.setAttribute('aria-selected', i === current);
    });
    thumbs.forEach((t, i) => t.classList.toggle('active', i === current));
  }

  function startAuto() {
    stopAuto();
    autoTimer = setInterval(() => goTo(current + 1), 4200);
  }

  function stopAuto() {
    if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
  }

  /* Arrow buttons */
  if (prevBtn) on(prevBtn, 'click', () => { stopAuto(); goTo(current - 1); startAuto(); });
  if (nextBtn) on(nextBtn, 'click', () => { stopAuto(); goTo(current + 1); startAuto(); });

  /* Dot clicks */
  dots.forEach(d => {
    on(d, 'click', () => { stopAuto(); goTo(+d.dataset.index); startAuto(); });
  });

  /* Thumbnail clicks */
  thumbs.forEach(t => {
    on(t, 'click', () => { stopAuto(); goTo(+t.dataset.index); startAuto(); });
  });

  /* Touch swipe */
  on(track, 'touchstart', e => {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    stopAuto();
    track.style.transition = 'none';
  }, { passive: true });

  on(track, 'touchmove', e => {
    const dx = e.touches[0].clientX - touchStartX;
    const dy = e.touches[0].clientY - touchStartY;
    if (Math.abs(dy) > Math.abs(dx)) return; /* vertical scroll */
    dragOffset = dx;
    const base = -current * 100;
    const pct  = (dragOffset / gallery.offsetWidth) * 100;
    track.style.transform = `translateX(calc(${base}% + ${dragOffset}px))`;
  }, { passive: true });

  on(track, 'touchend', e => {
    const dx = e.changedTouches[0].clientX - touchStartX;
    track.style.transition = 'transform 0.46s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    if (Math.abs(dx) > 30) {
      goTo(dx < 0 ? current + 1 : current - 1);
    } else {
      goTo(current);
    }
    dragOffset = 0;
    startAuto();
  }, { passive: true });

  /* Mouse drag (desktop) */
  on(track, 'mousedown', e => {
    isDragging = true;
    dragStartX = e.clientX;
    track.style.transition = 'none';
    track.style.cursor = 'grabbing';
    stopAuto();
  });

  on(window, 'mousemove', e => {
    if (!isDragging) return;
    dragOffset = e.clientX - dragStartX;
    track.style.transform = `translateX(calc(-${current * 100}% + ${dragOffset}px))`;
  });

  on(window, 'mouseup', e => {
    if (!isDragging) return;
    isDragging = false;
    track.style.cursor = '';
    const dx = e.clientX - dragStartX;
    track.style.transition = 'transform 0.46s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    if (Math.abs(dx) > 60) {
      goTo(dx < 0 ? current + 1 : current - 1);
    } else {
      goTo(current);
    }
    dragOffset = 0;
    startAuto();
  });

  /* Keyboard */
  on(gallery, 'keydown', e => {
    if (e.key === 'ArrowLeft')  { stopAuto(); goTo(current - 1); startAuto(); }
    if (e.key === 'ArrowRight') { stopAuto(); goTo(current + 1); startAuto(); }
  });

  /* Pause on hover */
  on(gallery, 'mouseenter', stopAuto);
  on(gallery, 'mouseleave', startAuto);

  goTo(0, false);
  startAuto();
}

/* ── PDP: QUANTITY ───────────────────────────────────── */
function initPDPQty() {
  const minus = $('#pdpQtyMinus');
  const plus = $('#pdpQtyPlus');
  const num = $('#pdpQtyNum');
  const inp = $('#pdpQtyInput');
  if (!minus) return;
  let qty = 1;
  const update = () => {
    if (num) num.textContent = qty;
    if (inp) inp.value = qty;
  };
  on(minus, 'click', () => { if (qty > 1) { qty--; update(); } });
  on(plus, 'click', () => { qty++; update(); });
}

/* ── PDP: STICKY BAR ─────────────────────────────────── */
function initPDPStickyBar() {
  const bar = $('#pdpStickyBar');
  const atcSection = $('#pdpAtcSection');
  if (!bar || !atcSection) return;
  new IntersectionObserver(([e]) => {
    bar.classList.toggle('visible', !e.isIntersecting);
  }, { threshold: 0 }).observe(atcSection);
}

/* ── PDP: TABS ───────────────────────────────────────── */
function initPDPTabs() {
  const btns = $$('.pdp-tab-btn');
  const panels = $$('.pdp-tab-content');
  if (!btns.length) return;
  btns.forEach(btn => {
    on(btn, 'click', function () {
      btns.forEach(b => { b.classList.remove('active'); b.setAttribute('aria-selected', 'false'); });
      panels.forEach(p => p.classList.remove('active'));
      this.classList.add('active');
      this.setAttribute('aria-selected', 'true');
      const panel = $('#' + this.dataset.tab);
      if (panel) panel.classList.add('active');
    });
  });
}

/* ── FAQ ACCORDION ───────────────────────────────────── */
function initFAQ() {
  $$('.faq-question').forEach(btn => {
    on(btn, 'click', function () {
      const item = this.closest('.faq-item');
      const wasOpen = item.classList.contains('open');
      $$('.faq-item').forEach(i => i.classList.remove('open'));
      if (!wasOpen) item.classList.add('open');
    });
  });
}

/* ── STAT COUNTER ANIMATION ──────────────────────────── */
function animateCounter(el) {
  const target = parseFloat(el.dataset.counter);
  const suffix = el.dataset.suffix || '';
  const prefix = el.dataset.prefix || '';
  if (isNaN(target)) return;

  const duration = 1800;
  const start = performance.now();
  const isInt = Number.isInteger(target);

  function step(now) {
    const elapsed = now - start;
    const progress = Math.min(elapsed / duration, 1);
    /* Ease-out cubic */
    const eased = 1 - Math.pow(1 - progress, 3);
    const value = target * eased;
    el.textContent = prefix + (isInt ? Math.round(value) : value.toFixed(0)) + suffix;
    if (progress < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}

function initCounters() {
  if (prefersReducedMotion()) {
    $$('[data-counter]').forEach(el => {
      const t = el.dataset.counter;
      const suffix = el.dataset.suffix || '';
      const prefix = el.dataset.prefix || '';
      el.textContent = prefix + t + suffix;
    });
    return;
  }

  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting && !e.target.dataset.counted) {
        e.target.dataset.counted = 'true';
        animateCounter(e.target);
      }
    });
  }, { threshold: 0.5 });

  $$('[data-counter]').forEach(el => obs.observe(el));
}

/* ── PAGE ENTRANCE ───────────────────────────────────── */
function initPageEntrance() {
  if (prefersReducedMotion()) return;
  document.body.style.opacity = '0';
  document.body.style.transition = 'opacity 0.4s ease';
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      document.body.style.opacity = '1';
    });
  });
}

/* ── INIT ────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', () => {
  initPageEntrance();
  cartDrawer.init();
  initStickyHeader();
  initMobileNav();
  initScrollReveal();
  initProductFilter();
  initPDPGallery();
  initPDPQty();
  initPDPStickyBar();
  initPDPTabs();
  initFAQ();
  initCounters();
});
